import type { Composition } from '@buying/library';

import { randNumber } from '@ngneat/falso';

import { mockRawMaterial } from './mockRawMaterial';

export const mockComposition = (
    overwrite?: Partial<Composition>
): Composition => ({
    rawMaterial: mockRawMaterial(),
    percentage: randNumber({ min: 1, max: 100 }),
    ...overwrite,
});
